import React, { useEffect, useRef, useState } from 'react';
import { Paper, Typography, Modal, Backdrop, Fade, IconButton } from '@mui/material';
import { ReactComponent as ToolTipIcon } from "assets/svg/Tooltip.svg";
import { ReactComponent as ToolTipIcon_Lean } from "assets/svg/Tooltip_Lean.svg";
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';
import "./style.scss"

const Overlay = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1000000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TooltipContainer = styled(Paper)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  border-radius: 4px;
  max-width: 38%;
  background-color: white;
  margin-top: -50px; /* Adjust this value to align the tooltip vertically */
  outline: none;
  z-index: 1000001;
  border: 0;
    transform: scale(0.8);
  transition: opacity 0.3s, transform 0.3s;

  &.open {
    opacity: 1;
    transform: scale(1);
  }

  @media screen and (max-width: 750px) {
    width: 100% !important;
    max-width: 90% !important;
  }
`;


const TooltipHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
`;

const TooltipTitle = styled(Typography)`
  font-weight: bold;
  font-size: 16px;
`;

const TooltipContent = styled(Typography)`
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: 400
`;

const CloseButtonContainer = styled('div')`
  display: flex;
  align-items: center;
`;

const CloseButton = styled(IconButton)`
  margin-left: 10px;
`;

const TooltipButton = ({ title, content, contents, businessLine }) => {
    const [isOpen, setIsOpen] = useState(false);

    const tooltipRef = useRef(null);
    const { t } = useTranslation()
    const translatedContents = contents?.map((item) => t(item));

    const handleOpen = () => {
        setIsOpen(true);
        document.body.classList.add('body-overflow');
    };

    const handleClose = () => {
        setIsOpen(false);
        document.body.classList.remove('body-overflow');
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
                handleClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    return (
        <>
            <div className='c-pointer' onClick={handleOpen}>
          {businessLine == 'lean' ? <ToolTipIcon_Lean /> : <ToolTipIcon />}
                
            </div>
            {isOpen && (
                <Overlay>
                    <TooltipContainer ref={tooltipRef} className={isOpen ? 'open' : ''}>
                        <TooltipHeader>
                            <TooltipTitle>{title}</TooltipTitle>
                            <CloseButtonContainer>
                                <CloseButton size="small" onClick={handleClose}>
                                    <CloseIcon fontSize="small" />
                                </CloseButton>
                            </CloseButtonContainer>
                        </TooltipHeader>
                        {contents?.length > 2 &&
                            translatedContents.map((content, index) => (
                                <TooltipContent key={index}>{content}</TooltipContent>
                            ))}
                        {content?.length && <TooltipContent>{content}</TooltipContent>}
                    </TooltipContainer>
                </Overlay>
            )}
        </>
    );
};

export default TooltipButton;
